/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum NeighbourhoodBicycleInfrastructure {
    BICYCLE_INFRASTRUCTURE = 'BICYCLE_INFRASTRUCTURE',
    LOW_TRAFFIC = 'LOW_TRAFFIC',
    HIGH_TRAFFIC = 'HIGH_TRAFFIC',
}
